const MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

/**
 * Formats an ISO date (YYYY-MM-DD) as e.g. "Apr 12, 2026" without timezone drift.
 * Returns the input unchanged if it isn't a plain ISO date.
 */
/**
 * Bounded pixel height for an AcxDataGrid based on row count (grids need a fixed container
 * height; they don't auto-size). Shows at least 3 rows and caps at 10 before scrolling.
 */
export function gridHeight(rowCount: number): string {
    const rows = Math.min(Math.max(rowCount, 3), 10);
    return `${rows * 52 + 60}px`;
}

export function formatShortDate(iso?: string): string {
    if (!iso) return "";
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!match) return iso;
    const [, year, month, day] = match;
    const monthLabel = MONTHS[Number(month) - 1] ?? month;
    return `${monthLabel} ${Number(day)}, ${year}`;
}
